/** @jsx isolateComponent */
import { isolateComponent } from '@zapier/common-utils';
import { Colors, Grid, Icon, Link, Text } from '@zapier/design-system';
import { Fragment } from 'react';
import { css } from '@emotion/core';

const linkCss = css`
  all: unset;
  box-sizing: border-box;
  text-decoration: underline;
  cursor: pointer;
  outline-offset: 1px;
  // Fix Safari 13 issue with 'color' and 'all: unset'
  // (https://bugs.webkit.org/show_bug.cgi?id=158782).
  -webkit-text-fill-color: currentColor;

  outline: 1px solid transparent;

  color: ${Colors.blue};
  text-decoration: underline !important;
  &:hover {
    color: ${Colors.night};
  }
  &:focus {
    color: ${Colors.blue};
    outline-color: ${Colors.blue};
  }
`;

export const SalesContact = () => {
  const onClickStartSalesChat = (
    event: React.MouseEvent<HTMLAnchorElement>
  ) => {
    event.preventDefault();
    window.dispatchEvent(new Event('LinkClick.ContactForm.ChatWithSales'));
  };

  return (
    <Fragment>
      <Fragment>
        <div>
          <Grid alignItems="center" columns="20px 1fr" gap="16px">
            <Icon name="commentConvo" size={24} />
            <Text color="neutral800" type="paragraph3Semibold">
              <p>Would you like to ask a sales question?</p>
            </Text>
          </Grid>
          <Grid alignItems="center" columns="20px 1fr" gap="16px">
            <div css="width: 24px"></div>
            <Text color="neutral800" type="paragraph3">
              <p>
                You can{' '}
                <Link
                  id="start-sales-chat"
                  color={null}
                  css={linkCss}
                  onClick={onClickStartSalesChat}
                >
                  start a chat
                </Link>{' '}
                with our sales team to learn more.
              </p>
            </Text>
          </Grid>
        </div>
      </Fragment>
    </Fragment>
  );
};
